import {ValidationFlags, MissingData, RiskLevel} from "./types";

export const DefaultValidationFlags : ValidationFlags = {
    acceptedHighRisk: false,
    acceptedMissingData: MissingData.None,
    missingData: MissingData.None,
    riskLevel: RiskLevel.Low
}